import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import AddToCart from '../component/button/addToCart';
import { menuImageErrorHander } from '../functions/errorHander';
import { getAllPrices } from '../functions/getPrice';
import LazyImage from '../component/common/lazyLoad';

const RecsCard = ({ item, addOnsId, from, recsType, parentItemName }) => {
  // Use state
  const [openItemOptions, setOpenItemOptions] = useState(false);

  // Translation
  const { t } = useTranslation();

  // Redux
  const currentSymbol = useSelector((state) => state.restSetting?.Setting?.curr_sym);
  const restarantSettingFromRedux = useSelector((state) => state.restSetting?.Setting);
  const customCustomizableText =
    restarantSettingFromRedux?.settings?.custom_text?.menu_customization || t('customizable_text');

  // Other variables
  const allPrices = getAllPrices(item);
  const isCustomizable = item?.variations?.length > 0 || addOnsId.includes(item.id);
  const showImage = item.image_type != 0 ? true : false;

  const PriceData = (
    <div>
      <div className='fs-12 fw-400 d-flex gap-2 align-items-center'>
        <span className={`fs-11 ${allPrices?.priceCut ? 'colorDisable' : ''}`}>
          {currentSymbol} {allPrices?.offeringPriceText}
        </span>
        {allPrices?.priceCut ? `${currentSymbol} ${allPrices?.priceCutText}` : ''}
      </div>
      {isCustomizable ? <div className='fs-10 opacity-05'>{customCustomizableText}</div> : null}
    </div>
  );

  const AddToCartDiv = (
    <AddToCart
      openItemOptions={openItemOptions}
      setOpenItemOptions={setOpenItemOptions}
      item={item}
      allPrices={allPrices}
      imageUrl={item.img_40x40}
      itemName={item.name}
      itemId={item.id}
      variations={item.variations}
      addOnId={item.addon_ids}
      availability={item.is_available}
      itemStatus={item.status}
      restaurantId={restarantSettingFromRedux.id}
      from={from}
      recsType={recsType}
      parentItemName={parentItemName}
    />
  );

  const AddDesc = (
    <div className='break-word fs-12 fw-500 text-capitalize recs-line-clamp'>{item.name}</div>
  );

  return (
    <div className='recs__card'>
      <div className='recs__card-description'>
        {AddDesc}
        {PriceData}
      </div>
      {showImage && (
        <div className='recs__card-image-container'>
          <LazyImage
            className='recs__card-image'
            onError={menuImageErrorHander.bind(this)}
            src={item.img_175x175}
            alt={item.name}
            width='100%'
            onClick={() => setOpenItemOptions(true)}
          />
          <div className='recs__card-add-btn'>{AddToCartDiv}</div>
        </div>
      )}
      {!showImage && <div className='recs__card-add-btn--no-relative'>{AddToCartDiv}</div>}
    </div>
  );
};

export default RecsCard;
